import * as React from 'react';
import * as main from '../../main.module.scss';
import * as adv from './style.module.scss';
export const Advance = () => {
  return (
    <section className={adv.adv}>
      <div className="container">
        <div className={adv.wrap}>
          <div className={adv.left}>
            <h2 className={main.title}>Об Advance</h2>
            <p>
              Advance – это центр образовательных технологий, который помогает детям и взрослым учиться в 2-3 раза
              быстрее и с удовольствием.
            </p>
            <p>
              С 2009 года занимаемся развитием интеллектуального потенциала и повышением личной эффективности человека.
            </p>
          </div>
          <div className={adv.right}>
            <p>
              <b>Более 1 700 000</b>
            </p>
            <p>человек посетили наши пробные уроки и семинары</p>
            <p>
              <b>Более 85 000</b>
            </p>
            <p>человек прошли наши полные программы</p>
          </div>
        </div>
      </div>
    </section>
  );
};
